import { computed } from 'vue';
import { SHOW_EMAIL_SHARE } from '@/config/features';
import type { EmissionSuccessProps } from './types';

interface FlowTexts {
  successTitle: string;
  successSubtitle: string;
  infoSectionTitle: string;
  emailButtonText: string;
  downloadButtonText: string;
  documentsSubtitle: string;
  infoMessageText: string;
}

const EMISSION_TEXTS: FlowTexts = {
  successTitle: '¡Póliza Emitida Exitosamente!',
  successSubtitle: 'Tu póliza ha sido emitida y está lista. A continuación encontrarás todos los detalles.',
  infoSectionTitle: 'Información de tu Póliza',
  emailButtonText: 'Enviar por Correo',
  downloadButtonText: 'Descargar Todo',
  documentsSubtitle: SHOW_EMAIL_SHARE
    ? 'Descarga los documentos de tu póliza o envíalos por correo electrónico.'
    : 'Descarga los documentos de tu póliza.',
  infoMessageText: SHOW_EMAIL_SHARE
    ? 'Los documentos también han sido enviados a tu correo electrónico.\nGuarda estos documentos en un lugar seguro.'
    : 'Guarda estos documentos en un lugar seguro.',
};

const QUOTE_TEXTS: FlowTexts = {
  successTitle: '¡Cotización Guardada Exitosamente!',
  successSubtitle: 'Tu cotización ha sido guardada con tus datos. Un agente se pondrá en contacto contigo pronto.',
  infoSectionTitle: 'Información de tu Cotización',
  emailButtonText: 'Enviar Cotización por Correo',
  downloadButtonText: 'Descargar Cotización',
  documentsSubtitle: SHOW_EMAIL_SHARE
    ? 'Descarga los documentos de tu cotización o envíalos por correo electrónico.'
    : 'Descarga los documentos de tu cotización.',
  infoMessageText: SHOW_EMAIL_SHARE
    ? 'Tu cotización ha sido enviada a tu correo electrónico.\nUn agente se pondrá en contacto contigo para continuar con el proceso.'
    : 'Un agente se pondrá en contacto contigo para continuar con el proceso.',
};

/** Texts and visibility flags that depend on whether the flow emitted a policy. */
export const useEmissionTexts = (props: EmissionSuccessProps) => {
  const texts = computed(() => (props.allowEmission ? EMISSION_TEXTS : QUOTE_TEXTS));
  const text = (key: keyof FlowTexts) => computed(() => texts.value[key]);

  return {
    successTitle: text('successTitle'),
    successSubtitle: text('successSubtitle'),
    infoSectionTitle: text('infoSectionTitle'),
    emailButtonText: text('emailButtonText'),
    downloadButtonText: text('downloadButtonText'),
    documentsSubtitle: text('documentsSubtitle'),
    infoMessageText: text('infoMessageText'),
    hasDocuments: computed(() => props.documentos && props.documentos.length > 0),
    showPolicyNumber: computed(() => props.allowEmission && props.policyData?.policyNumber),
  };
};
